<template>
  <div class="home">
    <div class="slider">
      <v-carousel
        :height="$vuetify.breakpoint.smAndDown ? 300 : 400"
        hide-delimiters
        show-arrows-on-hover
      >
        <v-carousel-item key="video">
          <video-player :options="videoOptions" :playsinline="true" />
        </v-carousel-item>
        <v-carousel-item v-for="(slide, i) in slider" :key="i">
          <v-img
            :src="slide"
            max-width="100%"
            :height="$vuetify.breakpoint.smAndDown ? 300 : 400"
          />
        </v-carousel-item>
      </v-carousel>
    </div>
    <quote class="quote-top">Schwarz Rot aus Überzeugung!</quote>
    <div class="home-news-container">
      <v-card class="mx-auto home-news" elevation="5">
        <v-card-text class="body-1 home-news-text">
          Die aktuellen Mitgliederzahlen des SV Westerheim sind wie folgt.<br />
          Die Gesamtmitgliederzahl im Jahr 2020 beträgt
          <dynamic-number :value="1204" /> Personen.<br />
          Davon sind <dynamic-number :value="671" :delay="333" /> männlich und
          <dynamic-number :value="533" :delay="333" /> weiblich.<br />
          <br />
          <span class="title"
            >Diese sind wie folgt auf die einzelnen Abteilungen verteilt:
          </span>
          <ul>
            <li>
              Turnen Erwachsensport & Jugend
              <dynamic-number :value="556" :delay="666" /> Personen
            </li>
            <li>
              Fußball Aktive & Jugend
              <dynamic-number :value="395" :delay="666" /> Personen
            </li>
            <li>
              Schwimmen
              <dynamic-number :value="145" :delay="666" /> Personen
            </li>
            <li>
              Tischtennis
              <dynamic-number :value="59" :delay="666" /> Personen
            </li>
            <li>
              Ski und Fahrrad
              <dynamic-number :value="44" :delay="666" /> Personen
            </li>
            <li>
              Volleyball
              <dynamic-number :value="56" :delay="666" /> Personen
            </li>
          </ul>

          <span class="title">Organisiert , Betreut und Trainiert:</span>
          <ul>
            <li>
              Turnen Erwachsensport & Jugend
              <dynamic-number :value="45" :delay="1000" /> Personen
            </li>
            <li>
              Fußball Aktive & Jugend & AH
              <dynamic-number :value="53" :delay="1000" /> Personen
            </li>
            <li>
              Schwimmen
              <dynamic-number :value="22" :delay="1000" /> Personen
            </li>
            <li>
              Tischtennis
              <dynamic-number :value="7" :delay="1000" /> Personen
            </li>
            <li>
              Ski und Fahrrad
              <dynamic-number :value="5" :delay="1000" /> Personen
            </li>
            <li>
              Volleyball
              <dynamic-number :value="5" :delay="1000" /> Personen
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.quote-top {
  padding-top: 8px;
}

.slider {
  align-self: center;
  width: 800px;
  max-width: 100%;
}

.home-news-container {
  padding: 8px;
}

.home-news-text {
  text-align: left;
}
</style>

<script>
import Quote from "../app/Quote";
import DynamicNumber from "../app/DynamicNumber";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { shuffle } from "../coach/shuffle";

const slider = shuffle([
  "images/impressions/impressions (1).jpg",
  "images/impressions/impressions (2).jpg",
  "images/impressions/impressions (3).jpg",
  "images/impressions/impressions (4).jpg",
  "images/impressions/impressions (5).jpg",
  "images/impressions/impressions (6).jpg",
  "images/impressions/impressions (7).jpg",
  "images/impressions/impressions (8).jpg",
  "images/impressions/impressions (9).jpg",
  "images/impressions/impressions (10).jpg",
  "images/impressions/impressions (11).jpg",
  "images/impressions/impressions (12).jpg",
  "images/impressions/impressions (13).jpg",
  "images/impressions/impressions (14).jpg",
  "images/impressions/impressions (15).jpg",
  "images/impressions/impressions (17).jpg",
  "images/impressions/impressions (19).jpg",
  "images/impressions/impressions (20).jpg",
  "images/impressions/impressions (21).jpg"
]);

export default {
  name: "home",
  components: {
    DynamicNumber,
    Quote,
    videoPlayer
  },
  data() {
    return {
      videoOptions: {
        width: 800,
        height: this.$vuetify.breakpoint.smAndDown ? 300 : 400,
        sources: [
          {
            type: "video/mp4",
            src: "/video/90-jahre-presentation.mp4"
          }
        ],
        poster: "/video/90-jahre-presentation.jpg"
      },
      slider
    };
  }
};
</script>
